/// <reference types="angular" />
/// <reference path="../../scripts/util.ts" />
/// <reference path="../../scripts/tokenAuthorization.js" />

var interceptorHeaderName = authTokenService.getAuthHeaderName();

angular.module('LBACompenSafeSite.AuthInterceptor', [])
    .factory('AuthApiInterceptor', function ($window, $q) {
        return {
            request: function (config) {
                var authToken = authTokenService.getUserToken();
                config.headers = config.headers || {};
                config.headers[interceptorHeaderName] = authToken;
                return config || $q.when(config);
            },
            response: function (response) {
                var responseData = authCommonResponse.get(response, $window);
                return response || $q.when(responseData);
            },
            responseError: function (rejection) {
                authCommonResponse.validate($window, rejection);
                return $q.reject(rejection);
            }
        };
    })
    .config(function ($httpProvider) {
        $httpProvider.interceptors.push('AuthApiInterceptor');
    });
